// extracted by mini-css-extract-plugin
export default {"rowDragActive":"MenteeModulesTableRow_rowDragActive__q0nAM"};